// All auth related apis
import axios from "axios";
import { BASEURL } from "./api";
import instance from "./api";

const API_URL = BASEURL + "/api";

// Ping for online/offline check
export const pingNetwork = async () => {
  return await axios.get(API_URL + "/ping");
}

// Post api for login with email and password
export const login = async (credentials) => {
  return await axios.post(API_URL + "/login", credentials);
};

// Post api for login with google
export const loginWithGoogle = async (credentials) => {
  return await axios.post(API_URL + "/login-with-google", credentials);
};

// Post api for registering new user
export const register = async (credentials) => {
  return await axios.post(API_URL + "/register", credentials);
};

// Post api for verifying the user otp to verify the email address after register
export const verifyUserOtp = async (credentials) => {
  return await axios.post(API_URL + "/verify-otp", credentials);
};

// Post api for requesting to resend otp
export const resendUserOtp = async (credentials) => {
  return await axios.post(API_URL + "/resend-otp", credentials);
};

// Post api for requesting the forgot-so-reset password
export const requestForgotPassword = async (credentials) => {
  return await axios.post(API_URL + "/request-forgot-password", credentials);
};

// Post api for verifying the otp for allowing password reset after forgot password request
export const verifyForgotPasswordOtp = async (credentials) => {
  return await axios.post(API_URL + "/forgot-password/verify-otp", credentials);
};

// Post api for resetting the password after the OTP verification for forgot password
export const resetPasswordOfForgotPassword = async (credentials) => {
  return await axios.post(
    API_URL + "/forgot-password/reset-password",
    credentials
  );
};

// Post api for registering the user with google - not in use (login with google is being used)
export const registerWithGoogle = async (credentials) => {
  return await axios.post(API_URL + "/register-with-google", credentials);
};

// Get api for fetching the user data with auth token
export const getUser = async (token) => {
  return await axios.get(API_URL + "/auth/get-user", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Post api for logging out the user that will delete the auth token
export const logoutUser = async (token) => {  
  return await axios.post(API_URL + "/logout", null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// Post api for updating the user's own account's details from profile
export const updateMyAccount = async (data) => {
  return await instance.post(API_URL + "/auth/update-my-account", data);
};

// Post api for updating the user's own account's password from profile
export const updateMyPassword = async (data) => {
  return await instance.post(API_URL + "/auth/change-my-password", data);
};

// Delete api for requesting user's own account delete
export const deleteMyAccount = async (data, source) => {
  return await instance.delete(
    API_URL + `/auth/delete-my-account?source=${source}`
  );
};

// Post api for requesting the user(Admin User)'s account after OTP verification for admin account delete
export const deleteAdminAccount = async (data, source) => {
  return await instance.post(
    API_URL + `/auth/delete-admin-account`,
    data
  );
};
